import { closeSnackbar, enqueueSnackbar, type SnackbarKey } from "notistack";

interface ShowToastOptions {
  autoHideDurationInMilliseconds?: number;
}

export function showSuccessToast(message: React.ReactNode, options?: ShowToastOptions) {
  const { autoHideDurationInMilliseconds } = options ?? {};

  return enqueueSnackbar({
    message,
    variant: "success",
    autoHideDuration: autoHideDurationInMilliseconds,
  });
}

export function showInfoToast(message: string, options?: ShowToastOptions) {
  const { autoHideDurationInMilliseconds } = options ?? {};

  return enqueueSnackbar({
    message,
    variant: "info",
    autoHideDuration: autoHideDurationInMilliseconds,
  });
}

export function showErrorToast(message: string, options?: ShowToastOptions) {
  const { autoHideDurationInMilliseconds } = options ?? {};

  return enqueueSnackbar({
    message,
    variant: "error",
    autoHideDuration: autoHideDurationInMilliseconds,
  });
}

export function showWarningToast(message: string, options?: ShowToastOptions) {
  const { autoHideDurationInMilliseconds } = options ?? {};

  return enqueueSnackbar({
    message,
    variant: "warning",
    autoHideDuration: autoHideDurationInMilliseconds,
  });
}

export function closeToast(toastKey: SnackbarKey) {
  closeSnackbar(toastKey);
}
